import { PortalName } from '@/common/DataModel/PortalData';
import {
  PortalSource,
  PortalIdentifier,
} from 'api/src/dataModels/PortalDataEnums';
import { LagoonContainerConfigItem } from '../../utils/formatLagoonData';
import { portalNameThemeMap } from '@/style/theme';
import { PortalThemeProps } from '@/common/DataModel/PortalThemeProps';

export enum ThemeVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export const parsedApp = (lineOfBusiness: string) => {
  switch (lineOfBusiness?.toLowerCase()) {
    default:
      return 'psx-web-umr';
  }
};

export const mapPortalToLob = (portalName: PortalName) => {
  switch (portalName?.toLowerCase()) {
    default:
      return 'umr';
  }
};

export const mapPortalToTheme = (
  portalName: PortalName,
  themeConfig?: Record<PortalName, LagoonContainerConfigItem>
) => {
  const portalThemeConfig = portalNameThemeMap[portalName];
  // source of truth for GEHA_THEME versioning for search-container as well as themeVersion for fpc-pcx
  const themeNameFromLagoon =
    themeConfig?.[portalName]?.value ?? ThemeVersion.V1;
  const themeLagoon =
    portalThemeConfig?.[themeNameFromLagoon as keyof typeof portalThemeConfig];
  const theme =
    portalThemeConfig?.[ThemeVersion.V1] ??
    portalNameThemeMap[PortalName.UMR]?.[ThemeVersion.V1];
  return themeLagoon ? themeLagoon : theme;
};

export const getPortalProps = (
  portalSource: PortalSource | undefined,
  portalIdentifier: PortalIdentifier | undefined,
  themeConfig?: Record<PortalName, LagoonContainerConfigItem>
): PortalThemeProps => {
  const isUmr = portalSource === PortalSource.UMR;
  const isGeha = portalIdentifier === PortalIdentifier.GEHA && isUmr;

  // Safely convert PortalSource to PortalName with proper type checking
  let portalSourceAsPortalName: PortalName;
  if (
    portalSource &&
    Object.values(PortalName).includes(portalSource as unknown as PortalName)
  ) {
    portalSourceAsPortalName = portalSource as unknown as PortalName;
  } else {
    portalSourceAsPortalName = PortalName.UMR;
  }

  const portalName = isGeha ? PortalName.GEHA : portalSourceAsPortalName;
  const portalTheme = mapPortalToTheme(portalName, themeConfig);
  const lob = mapPortalToLob(portalName);
  const appName = parsedApp(lob);
  return { portalName, portalTheme, lob, appName };
};
